import React from 'react';
import { useSidecarMode } from '../../context/SidecarModeContext';
import '../../styles/RadarBurstOverlay.css';

export const RadarBurstOverlay: React.FC = () => {
  const { burst } = useSidecarMode();

  if (!burst.show) return null;

  const isActivate = burst.kind === 'activate';

  return (
    <div className="radar-burst-overlay">
      {/* Dark overlay for dramatic effect */}
      <div className={`burst-backdrop ${isActivate ? 'activate' : 'deactivate'}`} />

      {/* Expanding rings */}
      {[0, 1, 2, 3, 4, 5].map((i) => (
        <div
          key={i}
          className={`burst-ring ${isActivate ? 'activate' : 'deactivate'}`}
          style={{
            left: burst.origin.x,
            top: burst.origin.y,
            animationDelay: `${i * 0.12}s`,
          }}
        />
      ))}

      {/* Radar sweep - only on activation */}
      {isActivate && (
        <div
          className="radar-sweep"
          style={{
            left: burst.origin.x,
            top: burst.origin.y,
          }}
        />
      )}

      {/* Center flash */}
      <div
        className={`center-flash ${isActivate ? 'activate' : 'deactivate'}`}
        style={{
          left: burst.origin.x,
          top: burst.origin.y,
        }}
      />

      {/* Secondary pulse for extra impact */}
      <div
        className={`center-pulse ${isActivate ? 'activate' : 'deactivate'}`}
        style={{
          left: burst.origin.x,
          top: burst.origin.y,
        }}
      />
    </div>
  );
};

export default RadarBurstOverlay;
